import PropTypes from 'prop-types';
import Pluralize from 'react-pluralize';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { Paper } from '@material-ui/core';
import dayjsPluginUTC from 'dayjs-plugin-utc';
import InfoBlock from '../../InfoBlock';

import useStyles from './styles';
import formatStateroomsInput from '../../../helpers/formatStateroomsInput';

dayjs.extend(dayjsPluginUTC);

const TourInfo = ({
  itinerary,
}) => {
  const classes = useStyles();
  const { staterooms } = useSelector((store) => store.tripSearch.searchObj);
  const { travelAgency } = useSelector((store) => store.user);

  return (
    <>
      <div className="grid grid-cols-4 gap-1">
        <div className="row-start-1 row-end-3">
          {itinerary.image
            ? (
              <img
                src={itinerary.image}
                alt="IMG"
              />
            ) : (
              <Paper square classes={classes}>
                No photo
              </Paper>
            )}
        </div>
        <div className="col-start-2 col-end-5 truncate">
          {itinerary.name}
        </div>
        <div className="col-start-2 col-end-5 truncate">
          {itinerary.selectedRate.name}
        </div>
      </div>
      <InfoBlock title="Tour details">
        <div className="grid grid-cols-2 text-sm">
          <div>Trip start:</div>
          <div>{dayjs(itinerary.fromDateTime).format('ddd D MMM, YYYY')}</div>
          <div>Trip end:</div>
          <div>{dayjs(itinerary.toDateTime).format('ddd D MMM, YYYY')}</div>
          {itinerary.duration
            ? (
              <>
                <div>Duration:</div>
                <div>
                  <Pluralize singular="night" count={itinerary.duration} />
                </div>
              </>
            ) : ''}
          <div>Travelers:</div>
          <div>
            {formatStateroomsInput(staterooms, travelAgency && travelAgency.enabledTransportModes)}
          </div>
          <div>Destination:</div>
          <div>{itinerary.destination}</div>
        </div>
      </InfoBlock>
    </>
  );
};

TourInfo.propTypes = {
  itinerary: PropTypes.shape().isRequired,
};

export default TourInfo;
